import { CSSObject } from "@emotion/react";
import {
  type AnchorStyleOverrides,
  type AngelouCSS,
  type ButtonStyleOverrides,
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const {
  breakpoints: { BreakpointNames },
} = constants;

const { mediaQuery: mq } = mediaQueryStyles;

export const alreadySignedInContainerCss: CSSObject = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  minWidth: "200px",
};

export const containerCss: CSSObject = {
  marginBottom: "32px",
  marginInline: "auto",
  display: "flex",
  flexDirection: "column",
  [mq.downTo(BreakpointNames.md)]: {
    flexDirection: "row",
  },
};

export const signInContainerCss: CSSObject = {
  flex: "1 1 353px",
};

export const titleCss: AngelouCSS = {
  ...typographyStyles.heading2,
  fontSize: "1.5rem",
  lineHeight: 1.1,
  textAlign: "center",
  color: constants.colors.ui.neutral[600],
  margin: "0 0 24px",
};

export const signInButtonCss: ButtonStyleOverrides<AngelouCSS> = {
  root: {
    borderRadius: 8,
  },
};

export const dividerContainerCss: CSSObject = {
  margin: "32px 0",
  flex: "1 1 1px",
  [mq.downTo(BreakpointNames.md)]: {
    margin: "0 32px",
  },
};

export const dividerCss: CSSObject = {
  margin: "32px 0",
  flex: "0 0 1px",
  border: "none",
  borderTop: `1px solid ${constants.colors.ui.neutral[100]}`,
  [mq.downTo(BreakpointNames.md)]: {
    borderTop: "none",
    borderLeft: `1px solid ${constants.colors.ui.neutral[100]}`,
    width: 1,
    margin: "0 32px",
  },
};

export const signInFormCss: CSSObject = {
  marginBottom: 16,
  [mq.downTo(BreakpointNames.md)]: {
    marginBottom: 8,
  },
};

export const usernameFieldCss: CSSObject = {
  marginBottom: 4,
  "& > div > span": {
    marginTop: 4,
    minHeight: 20,
    marginBottom: 0,
  },
};

export const passwordFieldCss: CSSObject = {
  marginBottom: 24,
  "& > div > span": {
    marginTop: 4,
    minHeight: 20,
    marginBottom: 0,
  },
};

export const centralizedContainerCss: CSSObject = {
  textAlign: "center",
};

export const resetPasswordAnchorCss: AnchorStyleOverrides<CSSObject> = {
  root: {
    color: constants.colors.ui.core[700],
    textDecoration: "none",
    marginBottom: 24,
  },
};

export const notMemberCss: CSSObject = {
  ...typographyStyles.textMObj,
  color: constants.colors.ui.neutral[600],
};

export const joinNowCss: AnchorStyleOverrides<CSSObject> = {
  root: {
    ...typographyStyles.textMObj,
    color: constants.colors.ui.core[700],
    padding: 0,
  },
};

export const toastCss: CSSObject = {
  root: {
    marginTop: 65,
  },
};

export const errorMessageCss: CSSObject = {
  "& a": {
    color: "inherit",
    fontSize: "inherit",
  },
};
